import React from 'react'
import {ChangeMobileFormat,addThousandPoint} from "../../../components/common/Common";

export const InputText = ({varMode,varName,varArrayInfo,onChangeHandler}) => {
  return (
    varMode===0?
      varArrayInfo[varName]
    :
      <input type="text" className="w_s_input" name={varName} 
              value={varName.indexOf('mobile')>0?ChangeMobileFormat(varArrayInfo[varName])
                    :varName.indexOf('fee')>0?addThousandPoint(varArrayInfo[varName])
                    :varArrayInfo[varName]||""
                    } onChange={(e)=>onChangeHandler(e)} 
      />
  )
}
export default InputText;